//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes material
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Grid, withStyles } from '@material-ui/core';
//Componentes
import Imagem from '../Imagem';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';

/** Importando documentação de modelos utilizados
 * @typedef {import('../../models/QuestionarioOpcaoResposta').default} QuestionarioOpcaoResposta
 */

/**
 * Estilos do componente
 */
const styles = () => ({
    fieldset: {
        width: '100%'
    }
});

/**
 * Componente para renderizar um campo para responder uma questão do tipo multipla escolha
 */
class AvaliacaoRespostaMultiplaEscolha extends Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleRespostaChange = this.handleRespostaChange.bind(this);
        this.handleOutroChange = this.handleOutroChange.bind(this);
        this.handleOpcaoOutroChange = this.handleOpcaoOutroChange.bind(this);
        //Estado inicial
        this.state = {
            outroSelecionado: !!props.questao.outro
        };
    }

    /**
     * Trata quando uma opção é marcada ou desmarcada
     * @param {*} event Dados do evento
     */
    handleRespostaChange(event) {
        //Copia os dados da questão
        const questao = AvaliacaoResposta.clone(this.props.questao);
        //Converte o valor para um inteiro
        const opcaoSelecionada = event.target.value * 1;

        //Garante que a resposta é um array
        questao.resposta = questao.resposta ?? [];
        
        //Caso esteja marcado, adiciona na lista de respostas
        if (event.target.checked) 
            questao.resposta.push(opcaoSelecionada);
        else //Caso contrário remove da lista
            questao.resposta = questao.resposta.filter(opcao => opcao !== opcaoSelecionada);
        
        //Dispara o evento de alteração
        if (this.props.onChange)
            this.props.onChange(questao);
    }

    /**
     * Trata a alteração no campo `outro`
     * @param {*} event Dados do evento
     */
    handleOutroChange(event) {
        //Copia os dados da questão
        const questao = AvaliacaoResposta.clone(this.props.questao);
        //Preenche com o valor informado pelo usuário
        questao.outro = event.target.value;
        
        //Dispara o evento de alteração
        if (this.props.onChange)
            this.props.onChange(questao);
    }

    /**
     * Trata quando a opção 'Outro' é marcada ou desmarcada
     * @param {*} event Dados do evento
     */
    handleOpcaoOutroChange(event) {
        //Caso seja desmarcada
        if (!event.target.checked) {
            //Copia os dados da questão
            const questao = AvaliacaoResposta.clone(this.props.questao);
            //Limpa a resposta
            questao.outro = '';
            //Dispara o evento de alteração
            if (this.props.onChange)
                this.props.onChange(questao);
        }
        //Atualiza o estado do componente
        this.setState({ outroSelecionado: event.target.checked });
    }

    /**
     * Renderiza o campo de texto para a resposta livre caso a opção esteja marcada
     * @param {AvaliacaoResposta} questao Dados da questão
     * @returns {Object} Retorna o componente ou `undefined`
     */
    renderCampoOutro(questao) {
        if (this.state.outroSelecionado) {
            return (
                <TextField
                    type="text" 
                    placeholder="Descreva a resposta"
                    variant="standard" 
                    size="small"
                    fullWidth 
                    onChange={this.handleOutroChange}
                    value={questao.outro ?? ''} 
                />  
            );
        }
    }

    /**
     * Renderiza a opção "Outros" de acordo com a configuração da questão
     * @param {AvaliacaoResposta} questao Dados da questão
     * @returns {Object} Retorna o componente ou `undefined`
     */
    renderOpcaoOutro(questao) {
        if (questao.opcaoOutros) {
            return (
                <FormControlLabel
                    control={<Checkbox checked={this.state.outroSelecionado} onChange={this.handleOpcaoOutroChange} />}
                    label="Outro"
                />
            );
        }
    }

    /**
     * Renderiza o label da opção de resposta de acordo com os dados
     * @param {QuestionarioOpcaoResposta} opcao Dados da opção
     * @returns {Object} Retorna o componente ou a descrição da opção
     */
    renderLabelOpcao(opcao) {
        //Caso a opção possua uma imagem
        if (opcao.imagem) {
            return (
                <Fragment>
                    <Imagem alt={opcao.descricao} src={opcao.imagem} />
                    <Typography>{opcao.descricao}</Typography>
                </Fragment>
            );
        } else {
            //Retorna apenas a descrição
            return opcao.descricao;
        }
    }

    render() {

        /** @type {AvaliacaoResposta} */
        const questao = this.props.questao;
        const resposta = questao.resposta ?? [];
        const erro = this.props.erro;
        
        //Identificando mensagem de erro (Erro geral tem preferência)
        let mensagemErro = '';
        if (erro.erroResposta)
            mensagemErro = erro.erroResposta;
        else if (Array.isArray(erro.resposta))
            mensagemErro = erro.resposta.join('\n');
        else
            mensagemErro = erro.resposta;
        
        return (
            <Grid item xs={12} >
                <FormControl component="fieldset" className={this.props.classes.fieldset} error={!!mensagemErro} >
                    <FormLabel component="legend">{questao.titulo}</FormLabel>
                    <FormGroup>
                        <Grid container spacing={1} justify="space-between" >
                            {
                                questao.opcoes.map(opcao => (
                                    <Grid item key={opcao.id} xs={12} sm={6} md={3} >
                                        <FormControlLabel
                                            control={<Checkbox value={opcao.id} checked={resposta.includes(opcao.id)} onChange={this.handleRespostaChange} />}
                                            label={this.renderLabelOpcao(opcao)}
                                        />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </FormGroup>
                    { this.renderOpcaoOutro(questao) }
                    { this.renderCampoOutro(questao) }
                    <FormHelperText>{mensagemErro}</FormHelperText>
                </FormControl>
            </Grid>
        );
    }
}

AvaliacaoRespostaMultiplaEscolha.propTypes = {
    /** Objeto contendo os dados da questão a ser respondida */
    questao: PropTypes.instanceOf(AvaliacaoResposta).isRequired,
    /** Evento disparado quando a resposta for alterada */
    onChange: PropTypes.func,
    /** Mensagens de erro da resposta */
    erro: PropTypes.shape({ 
        resposta: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string ]),
        erroResposta: PropTypes.string
    }),
    /** Classes CSS para personalização do componente */
    classes: PropTypes.shape({
        fieldset: PropTypes.string
    })
};

AvaliacaoRespostaMultiplaEscolha.defaultProps = {
    erro: {
        resposta: [ ],
        erroResposta: ''
    }
};

export default withStyles(styles)(AvaliacaoRespostaMultiplaEscolha);